import React from 'react';
import {
  FaUserTie, FaBalanceScale, FaCalculator, FaBuilding, FaShieldAlt, FaHeart
} from 'react-icons/fa';

export const API = '/api';

// Professional type icons and labels
export const PROFESSIONAL_TYPES = {
  financial_advisor: { icon: FaUserTie, label: 'Financial Advisor', color: 'blue' },
  estate_attorney: { icon: FaBalanceScale, label: 'Estate Attorney', color: 'purple' },
  cpa_tax: { icon: FaCalculator, label: 'CPA & Tax Expert', color: 'green' },
  real_estate: { icon: FaBuilding, label: 'Real Estate Expert', color: 'amber' },
  insurance: { icon: FaShieldAlt, label: 'Insurance Specialist', color: 'red' },
  family_therapist: { icon: FaHeart, label: 'Family Therapist', color: 'pink' }
};

export function TabButton({ icon, label, active, onClick, count }) {
  return (
    <button
      onClick={onClick}
      className={`flex items-center space-x-2 px-4 py-4 border-b-2 font-medium transition ${
        active
          ? 'border-blue-600 text-blue-600'
          : 'border-transparent text-gray-600 hover:text-gray-800'
      }`}
    >
      {icon}
      <span>{label}</span>
      {count > 0 && (
        <span className={`text-xs px-2 py-0.5 rounded-full ${
          active ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-600'
        }`}>
          {count}
        </span>
      )}
    </button>
  );
}
